import React, { useEffect, useState } from "react";

// Pinta una sección del menú a partir de lo que viene de DynamoDB.
// Cada sección define su "layout" (tipo de lista, lado de la foto, etc.)
// para que el panel pueda crear secciones nuevas sin tocar código.

export const precioDesde = (seccion, productos) => {
  const precios = (seccion.precios || []).map((p) => p.precio);
  const base = precios.length
    ? precios
    : productos.filter((p) => p.disponible !== false && p.precio != null).map((p) => p.precio);
  return base.length ? Math.min(...base) : null;
};

export function SeccionHeader({ eyebrow, titulo }) {
  return (
    <div className="seccion-header">
      {eyebrow && <div className="seccion-eyebrow">{eyebrow}</div>}
      <h2 className="seccion-titulo">{titulo}</h2>
      <div className="seccion-linea"></div>
    </div>
  );
}

export function SubHeader({ titulo }) {
  return (
    <div className="subseccion-header">
      <h3 className="subseccion-titulo">{titulo}</h3>
      <div className="subseccion-linea"></div>
    </div>
  );
}

function TablaPreciosCard({ precios, titulo }) {
  return (
    <div className="precios-tabla">
      <div className="tabla-header">{titulo}</div>
      {precios.map((p) => (
        <div key={p.etiqueta} className="tabla-row">
          <span className="tabla-tamano">{p.etiqueta}</span>
          <span className="tabla-rebanadas">{p.detalle}</span>
          <span className="tabla-precio">${p.precio}</span>
        </div>
      ))}
    </div>
  );
}

function Carousel({ images, alt }) {
  const [i, setI] = useState(0);
  const total = images.length;
  const actual = i % total;
  const go = (dir) => setI((prev) => (prev + dir + total) % total);

  useEffect(() => {
    if (total <= 1) return;
    const timer = setInterval(() => {
      setI((prev) => (prev + 1) % total);
    }, 3000);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <div className="carousel-imgs">
      {images.map((img, idx) => (
        <img
          key={img.src}
          src={img.src}
          alt={img.caption || alt}
          className={`carousel-slide ${idx === actual ? "active" : ""}`}
        />
      ))}
      {total > 1 && (
        <>
          <button type="button" className="carousel-arrow left" onClick={() => go(-1)} aria-label="Anterior">‹</button>
          <button type="button" className="carousel-arrow right" onClick={() => go(1)} aria-label="Siguiente">›</button>
          <div className="carousel-dots">
            {images.map((_, idx) => (
              <span
                key={idx}
                className={`carousel-dot ${idx === actual ? "active" : ""}`}
                onClick={() => setI(idx)}
              />
            ))}
          </div>
        </>
      )}
      {images[actual]?.caption && <div className="carousel-caption">{images[actual].caption}</div>}
    </div>
  );
}

function FotoSeccion({ seccion, productos }) {
  const imagenes = seccion.imagenes || [];
  const tamano = seccion.layout?.fotoTamano;
  const clase = `alitas-foto ${tamano === "tall" ? "alitas-foto-tall" : tamano === "md" ? "alitas-foto-md" : ""}`;

  if (imagenes.length > 1) {
    return (
      <div className={clase}>
        <Carousel images={imagenes} alt={seccion.nombre} />
      </div>
    );
  }

  const precio = precioDesde(seccion, productos);
  const overlay = seccion.overlay;

  return (
    <div className={clase}>
      <img src={imagenes[0].src} alt={imagenes[0].caption || seccion.nombre} />
      {overlay && precio != null && (
        <div className={`alitas-foto-overlay ${seccion.layout?.overlayArriba ? "alitas-foto-overlay-top" : ""}`}>
          <div className="alitas-foto-precio">
            {overlay.label && <span className="afp-label">{overlay.label}</span>}
            <span className="afp-precio">${precio}</span>
            {overlay.sub && <span className="afp-sub">{overlay.sub}</span>}
          </div>
        </div>
      )}
    </div>
  );
}

const Agotado = () => <span className="tag-agotado">Agotado</span>;

function ListaProductos({ tipo, productos, variante }) {
  if (tipo === "lista") {
    return (
      <div className="pizza-lista">
        {productos.map((p) => (
          <div key={p.productoId} className={`pizza-item ${p.disponible === false ? "agotado" : ""}`}>
            <div className="pizza-nombre">
              {p.nombre}
              {p.precio != null && <span className="pizza-precio-propio"> · ${p.precio}</span>}
              {p.disponible === false && <Agotado />}
            </div>
            {p.descripcion && <div className="pizza-ingredientes">{p.descripcion}</div>}
          </div>
        ))}
      </div>
    );
  }

  if (tipo === "chips") {
    return (
      <div className="sabores-grid">
        {productos.map((p) => (
          <span key={p.productoId} className={`sabor-chip ${p.disponible === false ? "agotado" : ""}`}>
            {p.nombre}
            {p.disponible === false && <Agotado />}
          </span>
        ))}
      </div>
    );
  }

  if (tipo === "tarjetas-compactas") {
    return (
      <div className="papas-grid-nuevo">
        {productos.map((p) => (
          <div key={p.productoId} className={`papa-card-nuevo ${p.disponible === false ? "agotado" : ""}`}>
            <div className="papa-card-info">
              <span className="papa-card-nombre">
                {p.nombre}
                {p.disponible === false && <Agotado />}
              </span>
              {p.descripcion && <span className="papa-card-desc">{p.descripcion}</span>}
            </div>
            {p.precio != null && <span className="papa-card-precio">${p.precio}</span>}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="bebidas-grid">
      {productos.map((p) => (
        <div key={p.productoId} className={`bebida-card ${variante || ""} ${p.disponible === false ? "agotado" : ""}`}>
          <div className="bebida-card-info">
            <span className="bebida-card-nombre">
              {p.nombre}
              {p.disponible === false && <Agotado />}
            </span>
            {p.descripcion && <span className="bebida-card-desc">{p.descripcion}</span>}
          </div>
          {p.precio != null && <span className="bebida-card-precio">${p.precio}</span>}
        </div>
      ))}
    </div>
  );
}

function ContenidoSeccion({ seccion, productos }) {
  const precios = seccion.precios || [];
  const extras = seccion.extras;
  const desde = precioDesde(seccion, productos);
  const desdeProductos = precioDesde({ precios: [] }, productos);

  return (
    <>
      {seccion.mostrarTablaPrecios && precios.length > 0 && (
        <TablaPreciosCard precios={precios} titulo={seccion.tituloTabla || "Precios"} />
      )}

      {seccion.encabezado && (
        <div className="alitas-sabores-titulo">
          {seccion.encabezado}
          {(desde != null || seccion.descripcion) && (
            <span className="titulo-desde">
              {[desde != null ? `$${desde}` : null, seccion.descripcion].filter(Boolean).join(" · ")}
            </span>
          )}
        </div>
      )}

      {extras?.opciones?.length > 0 && (
        <div className="orilla-badge">
          <div className="orilla-titulo">
            {extras.titulo}
            {extras.destacado && <strong>{extras.destacado}</strong>}
          </div>
          <div className="orilla-opciones">
            {extras.opciones.map((o) => (
              <div key={o.etiqueta} className="orilla-opcion">
                <div className="op-label">{o.etiqueta}</div>
                <div className="op-precio">
                  {o.suma !== false ? "+" : ""}${o.precio}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {productos.length > 0 && (
        <>
          {seccion.itemsTitulo && (
            <div className="alitas-sabores-titulo">
              {seccion.itemsTitulo}
              {seccion.itemsTituloDesde && desdeProductos != null && (
                <span className="titulo-desde">desde ${desdeProductos}</span>
              )}
            </div>
          )}
          <ListaProductos
            tipo={seccion.layout?.lista}
            productos={productos}
            variante={seccion.layout?.variante}
          />
        </>
      )}
    </>
  );
}

export default function SeccionMenu({ seccion, productos }) {
  const layout = seccion.layout || {};
  const tieneFoto = (seccion.imagenes || []).length > 0;
  const anchoFoto = layout.anchoFoto || 6;
  const fotoDerecha = layout.fotoLado === "der";
  const conBloques = seccion.mostrarTablaPrecios || seccion.encabezado || seccion.extras?.opciones?.length;

  // En móvil la foto siempre va primero; en escritorio respeta el lado elegido.
  const colFoto = `col-12 col-md-${anchoFoto} order-1 ${fotoDerecha ? "order-md-2" : "order-md-1"} ${
    layout.fotoTamano === "md" ? "d-flex align-items-center" : ""
  }`;
  const colContenido = `col-12 ${tieneFoto ? `col-md-${12 - anchoFoto}` : ""} d-flex flex-column ${
    seccion.mostrarTablaPrecios ? "" : "justify-content-center"
  } ${conBloques ? "gap-3" : ""} order-2 ${fotoDerecha ? "order-md-1" : "order-md-2"}`;

  return (
    <div className="row g-4 align-items-stretch">
      {tieneFoto && (
        <div className={colFoto}>
          <FotoSeccion seccion={seccion} productos={productos} />
        </div>
      )}
      <div className={colContenido}>
        <ContenidoSeccion seccion={seccion} productos={productos} />
      </div>
    </div>
  );
}
